<template>
  <div class="main-footer-controls grid-12 grid-md-6 grid-lg-4">
    <div class="g-6 g-md-3 g-lg-2">
      <ChangeLanguage :small="$mqAliases.desktop" />
    </div>

    <div class="g-6 g-md-3 g-lg-2">
      <div class="d-flex justify-content-end" style="max-width: 100%">
        <ChangeShipping :small="$mqAliases.desktop" />
      </div>
    </div>
  </div>
</template>
<script>
import ChangeShipping from '@/Scripts/components/shared/Shipping/ChangeSelect.vue';
import ChangeLanguage from '@/Scripts/components/shared/Language/ChangeSelect.vue';

export default {
  components: {
    ChangeShipping,
    ChangeLanguage
  }
};
</script>
